const translations = {
  'wWithUs.seo.title': 'Trabaja con nosotros en Barcelona y Sevilla España',
  'wWithUs.seo.description':
    'Obtén más información sobre cómo trabajar como formador de profesores en nuestros prestigiosos cursos Trinity CertTESOL en Barcelona y Sevilla.',
  'wWithUs.sec1.title': '¡TEFL Iberia está contratando!',
  'wWithUs.sec1.description':
    'Estamos buscando tutores de cursos calificados para nuestros cursos Trinity CertTESOL en Barcelona y Sevilla. El rol principal es liderar sesiones de enseñanza matutinas para el curso Trinity CertTESOL, evaluar a los estudiantes y colaborar con Trinity College London. ',
  'wWithUs.sec1.description2':
    'También estamos aceptando solicitudes para posiciones de enseñanza de inglés dentro de nuestra escuela.',
  'wWithUs.sec1.c1.benefitsTitle': 'Las principales responsabilidades incluyen:',
  'wWithUs.sec1.c1.ben1': 'Preparar y liderar sesiones de enseñanza.',
  'wWithUs.sec1.c1.ben2': 'Desarrollar continuamente el curso.',
  'wWithUs.sec1.c1.ben3': 'Dar demostraciones de clases.',
  'wWithUs.sec1.c1.ben4': 'Evaluar a los estudiantes.',
  'wWithUs.sec1.c1.ben5': 'Organizar el horario de práctica de enseñanza.',
  'wWithUs.sec1.c1.ben6': 'Ser responsable del correcto funcionamiento del curso.',

  'wWithUs.sec1.c2.benefitsTitle': 'Requisitos esenciales:',
  'wWithUs.sec1.c2.ben1': 'Mínimo 4 años de experiencia de enseñanza en una variedad de contextos.',
  'wWithUs.sec1.c2.ben2': 'Un año de experiencia en formación de profesores.',
  'wWithUs.sec1.c2.ben3': 'Pasión por la enseñanza.',
  'wWithUs.sec1.c2.ben4':
    'Calificación en TEFL de nivel diploma (Cambridge DELTA, Trinity DipTESOL, PGCE en TEFL, etc.).',

  'wWithUs.sec1.c3.benefitsTitle': 'Deseables:',
  'wWithUs.sec1.c3.ben1': 'Estado de autónomo.',
  'wWithUs.sec1.c3.ben2': 'Experiencia previa en gestión o servicio al cliente.',
  'wWithUs.sec1.c3.ben3':
    'Conocimiento del plan de estudios y la organización de Trinity CertTESOL.',
  'wWithUs.sec1.c3.ben4': 'Estar dado de alta en el régimen de Autónomo',

  'wWithUs.sec2.notice':
    'Si estás interesado en unirte al equipo de TEFL Iberia, completa el formulario a continuación:',

  'wWithUs.sec2.form': 'Formulario de solicitud',
  'wWithUs.sec2.firstName': 'Nombre',
  'wWithUs.sec2.lastName': 'Apellido',
  'wWithUs.sec2.email': 'Correo electrónico',
  'wWithUs.sec2.tel': 'Teléfono',
  'wWithUs.sec2.nationality': 'Nacionalidad',
  'wWithUs.sec2.qualification': '¿Qué calificaciones de enseñanza tiene?  ',
  'wWithUs.sec2.spainStatus': '¿Cuál es su estado actual en España?',
  'wWithUs.sec2.selectOption': 'Seleccione su opción preferida',
  'wWithUs.sec2.coverLetter': 'Carta de presentación',
  'wWithUs.sec2.apply': 'Solicitar',
};

export default translations;
